import { AxiosResponse } from 'axios'

export class LockedError extends Error {
  public response: AxiosResponse

  constructor(response: AxiosResponse) {
    super()
    this.name = this.constructor.name
    this.response = response
  }
}
